import * as React from 'react';

function SvgTwitterMono(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.965 11.58c0-.178-.004-.355-.012-.531A8.344 8.344 0 0025 8.924a8.18 8.18 0 01-2.356.646 4.118 4.118 0 001.804-2.27 8.23 8.23 0 01-2.606.996 4.104 4.104 0 00-6.992 3.742 11.65 11.65 0 01-8.458-4.287 4.093 4.093 0 00-.556 2.063 4.1 4.1 0 001.826 3.415 4.073 4.073 0 01-1.858-.513v.053a4.105 4.105 0 003.291 4.022 4.108 4.108 0 01-1.853.07 4.108 4.108 0 003.833 2.85 8.232 8.232 0 01-5.096 1.757c-.331 0-.658-.02-.979-.057a11.616 11.616 0 006.29 1.843c7.548 0 11.675-6.253 11.675-11.675z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgTwitterMono;
